import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A diverse group of people engaging in a discussion about social issues" 
          className="hero-image" 
        />
        <p className="eyebrow">Smashing Ignorance</p>
        <h1>Smash Ignorance, Embrace Understanding.</h1>
        <p className="lede">
          Explore diverse cultures and social issues to foster awareness and empathy.
        </p>
      </header>

      <section className="cards">
        <h2>Discover, Learn, Engage</h2>
        <p>
          At Smashingtheignorance, we provide in-depth articles, personal stories, and resources on social justice and cultural awareness. Join us in the journey to expand your understanding and combat ignorance.
        </p>
        <a href="/articles" className="cta-button">Dive into Our Articles</a>
      </section>
    </div>
  );
}

export default App;